import { DeterministicView } from '@bingads-webui/deterministic-view';
import template from './option-template.pug';

export class Option extends DeterministicView {
  events() {
    return {
      'click .dropdown-search-selector__option': () => {
        this.trigger('optionSelected', this.getState());
      },
    };
  }

  get template() {
    return template;
  }

  getState() {
    const {
      id,
    } = this.model.attributes;

    return {
      id,
    };
  }

  setState({
    id = '', value = '', isSelected = false, isDisabled = false,
  }) {
    this.model.set({
      id,
      value,
      isSelected,
      isDisabled,
    });

    return this;
  }
}
